import { RootState } from "../reducers";

export const getDateFilter = ({ dateFilter }: RootState) => dateFilter;

export const getDateFilterConditions = ({ dateFilter }: RootState) => dateFilter.conditions;

export const getDateFilterLayers = ({ dateFilter }: RootState) => dateFilter.layers;
